export const authSelector = (state) => state.auth;
export const currentUserSelector = (state) => state.auth.user;
